import { render, staticRenderFns } from "./CollectionOptions.vue?vue&type=template&id=5db12376"
import script from "./CollectionOptions.vue?vue&type=script&lang=js"
export * from "./CollectionOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports